import { getTenantFromAccessToken } from '../../helpers/auth0'

export const getPageReferer = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }

  return window.location.href
}

export const defaultHeaders = (token: string): Headers => {
  const headers = new Headers()
  const tenant = getTenantFromAccessToken(token)

  headers.set('authorization', `Bearer ${token}`)
  headers.set('Content-Type', 'application/json')

  if (tenant) {
    headers.set('X-Tenant', tenant)
  }

  const referer = getPageReferer()
  if (referer) {
    headers.set('Referer', referer)
  }

  return headers
}

export const apiFetch = (
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> =>
  fetch(input, {
    ...init,
    referrerPolicy: init.referrerPolicy ?? 'unsafe-url',
  })
